import { gsap } from "gsap";

export function accordion() {
  // アコーディオンの開閉アニメーション
  const accordionGsap = () => {
    const accordions = document.querySelectorAll(".js-accordion");
    const isOpen = "is-open"; // アイコンの切り替え用クラス

    accordions.forEach((accordion) => {
      const summary = accordion.querySelector(".js-accordion-summary");
      const content = accordion.querySelector(".js-accordion-content");

      summary.addEventListener("click", (event) => {
        event.preventDefault(); // クリックイベントのキャンセル
        if (accordion.classList.contains(isOpen)) {
          accordion.classList.remove(isOpen); // アイコンの切り替え用クラスを削除
          closeAnimation(content, accordion).restart();
        } else {
          accordion.classList.add(isOpen); // アイコンの切り替え用クラスを追加
          accordion.setAttribute("open", "");
          openAnimation(content).restart();
        }
      });
    });
  };

  const clearAnimProps = "height,marginTop,borderTopWidth,borderBottomWidth";

  // アコーディオンが開くときのGSAPアニメーション
  const openAnimation = (content) => {
    const cs = window.getComputedStyle(content);
    const targetMargin = cs.marginTop;
    const borderTB = {
      borderTopWidth: cs.borderTopWidth,
      borderBottomWidth: cs.borderBottomWidth,
    };
    gsap.set(content, {
      height: 0,
      marginTop: 0,
      borderTopWidth: 0,
      borderBottomWidth: 0,
    });
    return gsap.fromTo(
      content,
      {
        height: 0,
        marginTop: 0,
        borderTopWidth: 0,
        borderBottomWidth: 0,
      },
      {
        height: "auto",
        marginTop: targetMargin,
        ...borderTB,
        duration: 0.3,
        ease: "power2.out",
        overwrite: true,
        onComplete: () => {
          gsap.set(content, { clearProps: clearAnimProps });
        },
      }
    );
  };

  // アコーディオンが閉じるときのGSAPアニメーション
  const closeAnimation = (content, element) => {
    const cs = window.getComputedStyle(content);
    const h = content.offsetHeight;
    const mt = cs.marginTop;
    const borderTB = {
      borderTopWidth: cs.borderTopWidth,
      borderBottomWidth: cs.borderBottomWidth,
    };
    return gsap.fromTo(
      content,
      { height: h, marginTop: mt, ...borderTB },
      {
        height: 0,
        marginTop: 0,
        borderTopWidth: 0,
        borderBottomWidth: 0,
        duration: 0.3,
        ease: "power2.out",
        overwrite: true,
        onComplete: () => {
          element.removeAttribute("open");
          gsap.set(content, { clearProps: clearAnimProps });
        },
      }
    );
  };

  accordionGsap();
}
